module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-numcard-row weex-ct weex-div",
    style: ({
      backgroundColor: this._backgroundColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9d7189c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d7189c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-numcard-row/index.vue
// module id = 650
// module chunks = 0 1